export interface TechnicalFeaturesGetApiRequest {
    task_id: string;
}

export interface TechnicalFeaturesGetApiResponse {
    text: string;
    features: {
        is_select: boolean;
        keywords: string[];
        reason: string;
        score: number;
        tech_feature: string;
        core?: boolean;
        user_add?: boolean;
        components?: string[];
    }[];
    /**
     * 阈值
     */
    threshold: number;
}

/**
 * 技术特征获取 API
 */
export interface FtoReportTechnicalFeaturesGetApi {
    /**
     * 获取技术特征
     * @param data 请求参数
     * @param signal abort 信号
     * @returns 技术特征
     */
    getTechnicalFeatures(data: TechnicalFeaturesGetApiRequest, signal?: AbortSignal): Promise<TechnicalFeaturesGetApiResponse>;
}

export const FtoReportTechnicalFeaturesGetApi = Symbol.for('FtoReportTechnicalFeaturesGetApi');
